<template>
    <div class="all">
        <div class="page-right w250 temp-right fr" v-if="!isPreview">
            <vue-scroll :ops="ops"  style="width:250px;height:100%">
                <div class="type-list">
                    <div class="type-top">
                        <h2 class=""><span class="switch" :class="status == 1 ? 'active' : ''" @click="oneButtonSwitch();">红头文件 <i class="icons switch-icon fr"></i></span></h2>
                    </div>
                    <div class="type-header">
                        <h2 class="title">选择模块</h2>
                    </div>
                    <draggable :list="list2" :options="{group:{name: falgs,pull:'clone'}, sort: false}" @end="end" class="dragArea">
                        <div v-for="element in list2" :key="element.id" class="list-complete-item text">
                            <i class="icons" :class="element.icon" v-show="element.type !== 1"></i>
                            <i class="iconfont" :class="element.icon" v-show="element.type === 1"></i>
                            {{element.name}}
                        </div>
                    </draggable>
                </div>
            </vue-scroll>
            
        </div>
        <div class="page-left pr260" v-if="!isPreview">
            <div class="detail-warp">
				<button class="btn btn-blue" @click="$router.go(-1)">返回列表</button>
                <div class="redHeader ac mt30" :class="status == 1 ? '' : 'hide'">
                    <input class="template-title ac db color-red" type="text" placeholder="填写红头文件标题" v-model="tempform.redFileTit"/>
                    <input class="template-author ac db" type="text" placeholder="填写红头文件编号" v-model="tempform.redFileName"/>
                    <img src="https://bsddata.oss-cn-hangzhou.aliyuncs.com/yuqing_oem/html/red_line.png">
                </div>
                <input class="template-title ac db mt20" type="text" placeholder="填写报告标题" v-model.trim="tempform.tit"/>
                <input class="template-author ac db" type="text" placeholder="填写作者名称" v-model.trim="tempform.name"/>
                <div class="dragWrap">
                    <draggable :list="list1" :options="{group:'article', disabled: disabled}" @start="start22" @end="end22" class="dragArea11">
                        <div v-for="(element, index) in list1" :key="index">
                            <div class="tit">
                                <i class="icons del-sm-icon mt5 fr" @click="handleDel(index, element.id,element.chartId)"></i>
                                <input class="name" type="text" v-model.trim="element.name"/>
                                <div class="tnumber">{{index+1<9?'0'+(index+1):index+1}}</div>
                                <span class="drop-down mores ml20" v-if="element.showCity">
                                    <button class="btn btn-lightblue"><span class="text">{{element.province}}</span><i class="icons"></i></button> 
                                    <ul class="option">
                                        <li class="repTem" v-for="(item, ind) in cityList" :key="ind" @click="choseCity(item.name,index,ind)">{{item.name}}</li>
                                    </ul>
                                </span>
                            </div>
                            <div class="cont ac mt15">
                                <img :src="element.img" v-if="element.img != ''"/>
                                <textarea type="text" v-if="element.isText" class="input-textarea"  v-model.trim="element.text"></textarea>
                            </div>
                        </div>
                    </draggable>
                </div>
                <div class="bottom ac mt20">
                    <button class="btn save btn-jbblue" :class="{ 'disabled': isActive==true }" @click="saveTemplete">保存模板</button>
                    <button class="btn save btn-jbblue ml20" @click="previewOpen" v-show="!isShow">预览模板</button>
                    <button class="btn save btn-none ml20" @click="previewBack" v-show="isShow">返回</button>
                </div>
            </div>
        </div>
        <div class="page-left" v-if="isPreview">
            <div class="detail-warp">
				<button class="btn btn-blue" @click="$router.go(-1)">返回列表</button>
                <div class="redHeader ac mt20" :class="status == 1 ? '' : 'hide'">
                    <div class="fs28 ac db color-red">{{tempform.redFileTit}}</div>
                    <p class="fs24 ac db mb10">{{tempform.redFileName}}</p>
                    <img src="https://bsddata.oss-cn-hangzhou.aliyuncs.com/yuqing_oem/html/red_line.png">
                </div>
                <div class="fs24 ac db">{{tempform.tit}}</div>
                <div class="mt20 ac db">{{tempform.name}}</div>
                <div class="dragWrap mt20">
                    <div class="dragArea11">
                        <div v-for="(element, index) in list1" :key="index">
                            <div class="d-flex">
                                <div class="tnumber">{{index+1<9?'0'+(index+1):index+1}}</div>
                                <div class="tit fs16 flex1">{{element.name}}</div>
                            </div>
                            <div class="cont ac mt15">
                                <p class="al" v-if="element.info!=undefined">{{element.info}}</p>    
                                <img :src="element.img" v-if="element.img != ''"/>
                                <div v-if="element.isText" class="al">{{element.text}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    components:{
        draggable
    }, 
    data() {
        return {
			imgUrl:'https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/',
            ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                    keepShow:true
                },
                bar: {
                    hoverStyle: true,
                    onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
                    background: '#c4c4cc',
                }
            },
            sid:this.$route.query.id,
            timeId:this.$route.query.timeId,//定时报告模板的ID
            isPreview:this.$route.query.isPreview,
            isFromTiming:this.$route.query.fromTiming,
            status:0,//红头文件显示状态
            tempform:{},
            falgs: 'article',
            disabled: false,
            list:[],
            list1: [],
            list2: [
                {id: 1, moduleType:'文本', isChart:false,name:'文本',icon:'text-icon',img:'',isText:1,text:'',chartId:'customText'}, 
                {id: 26, moduleType:'报告简述', isChart:false, name: '报告简述',icon:'text-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/js.png',text:'',chartId:'summary'},
                {id: 2, moduleType:'折线图', isChart:true,name:'趋势分析',icon:'data1-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qsfb.png',chartId:'reportTrend',info:'在分析时间段内，从综合传播变化趋势来看，方案上海传播热度在2022-07-20达到了峰值xx条，方案合肥传播热度在2022-07-22达到了峰值xx条，方案北京传播热度在2022-07-20达到了峰值xx条。'}, 
                {id: 3, moduleType:'分析词榜单', isChart:false,name:'分析词榜单',icon:'data1-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/fxcbd.png',chartId:'analyseWord'},
				{id: 4, moduleType:'文章', isChart:false,name:'热门文章',icon:'data1-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/wz.png',chartId:'hotArticle'},
                {id: 5, moduleType:'文章', isChart:false,name:'负面文章TOP',icon:'data1-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/wz.png',chartId:'negArticle'},
				{id: 6, moduleType:'柱状图', isChart:true,name:'情绪分布',icon:'data2-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qxfb.png',chartId:'moodDist',info:'在分析时间段内，针对“上海”方案的传播情绪主要集中在赞扬，达到了xx条；针对“合肥”方案的传播情绪主要集中在赞扬，达到了xx条；针对“北京”方案的传播情绪主要集中在赞扬，达到了xx条。'}, 
                {id: 7, moduleType:'折线组图', isChart:true,name:'情感分布',icon:'data1-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qgfb.png',chartId:'emotionDistLine',chartType:'折线图',info:'据下图可知，2019年08月08日 00:00:00至2019年08月14日 23:59:59，正面舆情信息xxx条，占比xx%；负面舆情信息xxx条，占比xx%；中性舆情信息xxx条，占比xx%。'}, 
                {id: 8, moduleType:'饼状图', isChart:true,name:'情感分布占比',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qgfbzb.png',chartId:'emotionDistPie',chartType:'折线图',info:'在分析时间段内，针对“上海”方案的情感属性主要集中在中性，达到了xx条（占比xx%）；针对“合肥”方案的情感属性主要集中在中性，达到了xx条（占比xx%）；针对“北京”方案的情感属性主要集中在中性，达到了xx条（占比xx%）。'}, 
                {id: 9, moduleType:'饼状图', isChart:true,name:'媒体分布',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/mtfb.png',chartId:'mediaDist',info:'在分析时间段内，“上海”方案已认证媒体分类主要分布在民企xx（占比xx%）；“合肥”方案已认证媒体分类主要分布在民企xx（占比xx%）；“北京”方案已认证媒体分类主要分布在民企xx（占比xx%）。'}, 
                {id: 10, moduleType:'柱状图', isChart:true,name:'平台分布',icon:'data2-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/ptfb.png',chartId:'platformDistColumn',info:'在分析时间段内，“上海”方案的主要传播平台集中在微博xx条（占比xx%）；“合肥”方案的主要传播平台集中在微博xx条（占比xx%）；“北京”方案的主要传播平台集中在微博xx条（占比xx%）。'}, 
                {id: 11, moduleType:'饼状图', isChart:true,name:'平台分布占比',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/ptfbzb.png',chartId:'platformDistPie',info:'在分析时间段内，“上海”方案的主要传播平台集中在微博xx条（占比xx%）；“合肥”方案的主要传播平台集中在微博xx条（占比xx%）；“北京”方案的主要传播平台集中在微博xx条（占比xx%）。'}, 
                {id: 12, moduleType:'柱状组图', isChart:true,name:'活跃渠道',icon:'data2-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qd.png',chartId:'activeChannel',info:'在分析时间段内，“上海”方案的主要传播活跃渠道集中在汽车之家xx条；“合肥”方案的主要传播活跃渠道集中在汽车之家xx条；“北京”方案的主要传播活跃渠道集中在汽车之家xx条。'},
                {id: 13, moduleType:'柱状组图', isChart:true,name:'敏感信息报道渠道',icon:'data2-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qd.png',chartId:'sensitiveChannel',info:'在分析时间段内，“上海”方案的主要传播敏感信息渠道集中在低调哥xx条；“合肥”方案的主要传播敏感信息渠道集中在东方之音xx条；“北京”方案的主要传播敏感信息渠道集中在中评网xx条。'},
                {id: 14, moduleType:'柱状组图', isChart:true,name:'影响力渠道',icon:'data2-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/qd.png',chartId:'impactChannel',info:'在分析时间段内，“上海”方案的主要传播影响力渠道集中在央视财经xx条；“合肥”方案的主要传播影响力渠道集中在新华社1条；“北京”方案的主要传播影响力渠道集中在新华社xx条。'},
                {id: 15, moduleType:'账号认证', isChart:true,name:'账号认证',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/zhrz.png',chartId:'accountAuth',info:'在分析时间段内，“上海”方案下的账号主要集中在未认证xx个（占比xx%）；“合肥”方案下的账号主要集中在未认证xx个（占比xx%）；“北京”方案下的账号主要集中在未认证xx个（占比xx%）。'},
                {id: 16, moduleType:'传播力分布', isChart:true,name:'传播力分布',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/wci.png',chartId:'spreadDist',info:'在分析时间段内，“上海”方案下的账号传播力分布（wci）主要集中在0-500内xx个（占比xx%）；“合肥”方案下的账号传播力分布（wci）主要集中在0-500内xx个（占比xx%）；“北京”方案下的账号传播力分布（wci）主要集中在0-500内xx个（占比xx%）。'},
                {id: 17, moduleType:'饼状图', isChart:true,name:'文章类型',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/wzlx.png',chartId:'articleType',info:'在分析时间段内，“上海”方案下的文章类型主要集中在社会xx条（占比xx%）；“合肥”方案下的文章类型主要集中在社会xx条（占比xx%）；“北京”方案下的文章类型主要集中在社会xx条（占比xx%）。'},
                {id: 18, moduleType:'词云图', isChart:true,name:'热门词云',icon:'yun-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/cy.png',chartId:'wordCloud',info:'在分析时间段内，“上海”方案中，被提及频次最高的TOP3词语分别为上海（xx）、中国（xx）、微博（xx）；“合肥”方案中，被提及频次最高的TOP3词语分别为合肥（xx）、产品（xx）、安徽（xx）；“北京”方案中，被提及频次最高的TOP3词语分别为北京（xx）、中国（xx）、时间（xx）。'},
                {id: 19, moduleType:'饼状图', isChart:true,name:'热门词云占比',icon:'ring-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/cyzb.png',chartId:'wordCloudPie',info:'在分析时间段内，“上海”方案中，被提及频次最高的TOP3词语分别为上海（xx）、中国（xx）、微博（xx）；“合肥”方案中，被提及频次最高的TOP3词语分别为合肥（xx）、产品（xx）、安徽（xx）；“北京”方案中，被提及频次最高的TOP3词语分别为北京（xx）、中国（xx）、时间（xx）。'},
                {id: 20, moduleType:'雷达图', isChart:true,name:'热门词云雷达',icon:'yun-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/ld.png',chartId:'wordCloudRadar',info:'在分析时间段内，“上海”方案中，被提及频次最高的TOP3词语分别为上海（xx）、中国（xx）、微博（xx）；“合肥”方案中，被提及频次最高的TOP3词语分别为合肥（xx）、产品（xx）、安徽（xx）；“北京”方案中，被提及频次最高的TOP3词语分别为北京（xx）、中国（xx）、时间（xx）。'},
                {id: 21, moduleType:'地图', isChart:true,name:'发布地区',icon:'map-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/map.png',chartId:'pubArea',showCity:true,province:'全国',numId:0,maxId:0,info:'在分析时间段内，“上海”方案下，发布信息地域主要集中在北京xx条（占比xx%）；“合肥”方案下，发布信息地域主要集中在北京xx条（占比xx%）；“北京”方案下，发布信息地域主要集中在北京xx条（占比xx%）。'},
                {id: 22, moduleType:'地图', isChart:true,name:'提及地区',icon:'map-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/map.png',chartId:'refArea',showCity:true,province:'全国',numId:0,maxId:0,info:'在分析时间段内，“上海”方案下，提及信息地域主要集中在上海xx条（占比xx%）；“合肥”方案下，提及信息地域主要集中在安徽xx条（占比xx%）；“北京”方案下，提及信息地域主要集中在北京xx条（占比xx%）。'},
                {id: 23, moduleType:'地图', isChart:true,name:'IP属地',icon:'map-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/map.png',chartId:'ipArea',showCity:true,province:'全国',numId:0,maxId:0,info:'在分析时间段内，“上海”方案下，关注者IP属地主要集中在上海xx条（占比xx%）；“合肥”方案下，关注者IP属地主要集中在安徽xx条（占比xx%）；“北京”方案下，关注者IP属地主要集中在江苏xx条（占比xx%）。'},
                {id: 24, moduleType:'横向柱状图', isChart:true,name:'网民观点',icon:'data2-icon',img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/wmgd.png',chartId:'netizenView'},
                {id: 25, moduleType:'媒体观点', isChart:false,name:'媒体观点',icon:'icon-wangminguandian',type:1,img:'http://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/static/images/compare/mtgd.png',chartId:'mediaView'}
            ],
            btNum : ['一','二','三','四','五','六','七','八','九'],
            cityList:[],
            tplInit:'',
            isShow:false,
            isActive:false,
            maxName:{'emotionDistribution':0,'wordCloud':0,'publishArea':0,'contentArea':0}
        }
    },
    mounted() {
        let that = this;
        that.cityAjax();
		if(that.sid!=undefined){
            that.editAjax();
        }
    },
    beforeDestroy(){
        let that = this;
        that.previewBack();
    },
    methods: {
        // 红头文件开关
        oneButtonSwitch () {
            let that = this;
            that.status = (that.status == 0)?1:0;
        },
        cityAjax(){
            let that = this;
            that.$axios.get('https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/json/city.json').then(r=>{
                that.cityList = r.data.arrCity; 
            }).catch(error =>{
                console.log(error);
            });

        },
        choseCity(name, index,num){
            this.list1[index].province = name;
            this.list1[index].img = this.$parent.baseUrl+'/static/images/report/province/mapImg'+num+'.gif';
        },
        choseEchart(name, index,num,id){
            this.list1[index].chartType = name;
            if(id=='emotionDistribution'){
                this.list1[index].img = this.imgUrl+'emotion_distribution'+num+'.png';
            }else if(id=='platformDistribution'){
                this.list1[index].img = this.imgUrl+'platform_distribution'+num+'.png';
            }else{
                this.list1[index].img = this.imgUrl+'word_cloud'+num+'.png';
            }    
        },
        end (ev) {
            let that = this;
            that.list = [];
            that.maxName={'emotionDistribution':0,'wordCloud':0,'publishArea':0,'contentArea':0};
            if(that.list1.length>0){
                that.list1.forEach((ele,index) => {
                    let tempArr = {};
                    if (ele.numId != undefined){console.log(ele.numId);
                        tempArr.numId = ele.numId;
                        that.maxName[ele.chartId]++;
                        ele.numId++;
                    }
                    tempArr.name = ele.name;
                    tempArr.img = ele.img;
                    tempArr.chartId = ele.chartId;
                    tempArr.isText = ele.isText;
                    tempArr.text = ele.text;
                    tempArr.showCity = ele.showCity;
                    tempArr.province = ele.province;
                    tempArr.maxId = ele.maxId;
                    tempArr.info = ele.info;
                    tempArr.isChart = ele.isChart;
                    tempArr.moduleType = ele.moduleType;
                    that.list.push(tempArr)
                }); 
                that.list1 = that.list;
            }
            if (ev.to.className === 'dragArea11') {
                //that.$set(that.list2[ev.oldIndex], 'flag', true)
            }
        },
        start22 (event) {
            this.falgs = '222222'
        },
        end22 (ev) {
            this.falgs = 'article'
        },
        handleDel (index, id ,chartId) {
            this.list1.splice(index, 1)
            let q = this.list2.find((value, index, arr) => {
                return value.id === id
            })
            //this.$set(q, 'flag', false)
        },
        //保存模板
        saveTemplete(){
            let that = this,tplHtml='',zlHtml='',rmHtml='',zlIndex=0,rmIndex=0,btIndex = 0,isHas1=false,isHas2 = false,isHas3 = false,has3Text='';
            
            if(that.tempform.tit == undefined || that.tempform.tit == ''){
                that.$utils.alertText('请填写报告标题',200);
                return;
            }
            if(that.list1.length ===0){
                that.$utils.alertText('请选择模块',200);
                return;
            }
            if(that.status===1 && (that.tempform.redFileTit == undefined || that.tempform.redFileTit == '')){
                that.$utils.alertText('请填写红头文件标题',200);
                return;
            }
            if(that.status===1 && (that.tempform.redFileName == undefined || that.tempform.redFileName == '')){
                that.$utils.alertText('请填写红头文件编号',200);
                return;
            }

            let data = {
                'openRedHeader':that.status,
                'redTitle':that.tempform.redFileTit,
                'redNumber':that.tempform.redFileName,
                'tplName':that.tempform.tit,
                'tplDesc':that.tempform.name,
                'tplCustom':that.list1,
                'tplType':'2',

            };
            that.isActive = true;
            that.$parent.loadModal(true,'正在保存...');
            
            if(that.sid==undefined){
                that.$api.post('monitor/compare/tpl-create',{data:data},r=>{
                    that.isActive = false;
                    that.$parent.returnCode(r,function(){
                        that.$parent.loadModal(false);
                        // that.$utils.alertText('报告添加成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'报告添加成功！'})
                        if(that.isFromTiming){
                            that.$router.push({ path:''+that.$parent.baseUrl+'/addCustomTemplate',query:{id:that.timeId}})
                        }else{
                            that.$router.push({ path:''+that.$parent.baseUrl+'/customTemplate'})
                        }
                    });
                });
            }else{
                data.id = that.sid;
                that.$api.post('monitor/compare/tpl-update',{data:data},r=>{
                    that.isActive = false;
                    that.$parent.returnCode(r,function(){
                        that.$parent.loadModal(false);
                        //that.$utils.alertText('报告修改成功！',200);
                        that.$store.dispatch('show/changeToast',{text:'报告修改成功！'})
                        that.$router.push({ path:''+that.$parent.baseUrl+'/customTemplate'})
                    });
                });
            }
            that.previewBack();
        },
        //预览模板
        previewOpen(){
            this.isShow = true;
            $('body').addClass('finalDraft');
        },
        previewBack(){
            this.isShow = false;
            $('body').removeClass('finalDraft');
        },
        //编辑模板
        editAjax(){
            let that = this;
            that.$api.get('monitor/compare/tpl-info',{id:that.sid},r=>{
                that.$parent.returnCode(r,function(){
                    that.status = parseInt(r.data.openRedHeader);
                    that.$set(that.tempform, 'redFileTit', r.data.redTitle);
                    that.$set(that.tempform, 'redFileName', r.data.redNumber);
                    that.$set(that.tempform, 'tit', r.data.tplName);
                    that.$set(that.tempform, 'name', r.data.tplDesc);
                    that.list1 = r.data.tplCustom;
                    that.list1.forEach((ele,index) => {
                        if (ele.numId != undefined){
                            that.maxName[ele.chartId] = ele.maxId;
                        }
                    });
                    that.list2.forEach((ele,index) => {
                        if (ele.numId != undefined){
                            ele.numId = that.maxName[ele.chartId];
                        }
                    });
                });            
            });
        }
    },
}
</script>
<style>
    .temp-right{width:250px;bottom:34px;top:103px;position:fixed;right:50px}
    .finalDraft{background-color: rgba(0, 0, 0, 0.8);}
    .finalDraft .left-menu,.finalDraft .top-menu,.finalDraft .page-right{display: none}
    .finalDraft .right-div{top:0}
    .dragArea11 .name{border: none;font-size: 16px; width: 500px;padding: 5px;}
    .tnumber{
        width: 48px;height: 30px;background: url(../../../static/images/ttbg.png) no-repeat;float: left;background-size: 100% 100%;
        text-align: center;line-height: 30px;color: #fff;font-size: 16px;
    }
</style>




// WEBPACK FOOTER //
// src/page/competingReports/addNewCustomTemplate.vue